export const ANNOUNCEMENTS_PAGE_ROOT_ID = 'announcements-page-root'
